import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import ReactTable from 'react-table';
import {ListButton, ViewTitle} from 'admin-on-rest';
import {RESOURCES as reportsResources} from '../fuseInventoryOrdersResourceMap';
import {
    addCommas,
    addFromColumn,
    convertDate,
    copyObjectArray,
    sortCurrency,
    sortArrayByKey,
    sortArrayByCurrencyKey,
    getTodayOffsetHour
} from '../shared/functions';
import {postInventoryOrderData} from '../shared/inventoryOrderFunctions';
import {getGetHeaders} from '../shared/serverFunctions';
import {getTableState, filterCaseInsensitive, setDefaultTableSort} from '../shared/tableFunctions';
import DialogInventoryOrderAdjustToAvailable from './DialogInventoryOrderAdjustToAvailable';
import DialogInventoryOrderConfirm from './DialogInventoryOrderConfirm';
import DialogInventoryOrderProductDetail from './DialogInventoryOrderProductDetail';
import DialogInventoryOrderResetOverrides from './DialogInventoryOrderResetOverrides';
import ExpandableTableContainer from './ExpandableTableContainer';
import InventoryOrderDetailTable from './InventoryOrderDetailTable';
import TableHeaderWithSort from './TableHeaderWithSort';
import Config from '../messages';
import FuseTheme from '../global/theme';
import {tableStyles} from '../shared/styles-table';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {Card, CardActions, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DetailIcon from 'material-ui/svg-icons/image/remove-red-eye';
import Icon from 'material-ui/svg-icons/action/today';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';

const ShowActions = ({basePath}) => (
    <CardActions style={viewStyles.actions}>
        <ListButton basePath={basePath}/>
    </CardActions>
);

const TotalsFilter = ({accessor, list = [], filteredList = []}) => {
    let total = '';
    let filteredTotal = '';
    if (list && list.length > 0 && accessor) {
        total = addCommas(addFromColumn(list, accessor));
        filteredTotal = addCommas(addFromColumn(filteredList, accessor));
    }
    const isFiltered = (total !== filteredTotal);
    const styles = {
        total: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            width: '100%',
            fontSize: 13,
            fontWeight: 'bold',
            textAlign: 'right',
            lineHeight: 1.3
        },
        focused: {
            color: '#212121',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            textOverflow: 'initial'
        },
        unFocused: {
            color: '#999999',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            textOverflow: 'initial'
        }
    };

    return (
        <span style={styles.total}>
            <span style={(isFiltered) ? styles.unFocused : styles.focused}>
                Total: {total}
            </span>
            {isFiltered &&
                <span style={styles.focused}>
                    Filtered: {filteredTotal}
                </span>
            }
        </span>
    )
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    qtyValue: {
        display: 'inline-block',
        marginRight: 8
    },
    qtyInput: {
        display: 'inline-block',
        textAlign: 'right',
        width: 74,
        marginTop: -3,
        padding: '3px 5px',
        border: '1px solid ' + FuseTheme.palette.borderColor,
        borderRadius: 3
    },
    qtyModified: {
        backgroundColor: FuseTheme.palette.modifiedColor
    }
};

/**
 * Inventory Order class for retrieving and displaying Order detail and Location data
 */
class InventoryOrderDetail extends Component {
    constructor(props) {
        super(props);

        const offsetHour = getTodayOffsetHour();

        this.state = {
            adjustAvailableOpen: false,
            categoryList: [],
            categoryTableData: [],
            confirmOrderOpen: false,
            confirmOrderType: 'submit',
            confirmRemoveDetail: null,
            confirmRemoveProductOpen: false,
            error: false,
            jobDetail: {
                job_id: '',
                job_user: '',
                job_name: '',
                location_id: '',
                location_name: '',
                x3_location_id: '',
                x3_location_name: '',
                warehouse: '',
                warehouse_initial: '',
                warehouse_restock: ''
            },
            jobId: props.match.params.job_id,
            locationId: props.match.params.location_id,
            loading: false,
            loadingLocation: false,
            loadingProduct: false,
            message: null,
            offsetHour: offsetHour,
            productDetail: null,
            productDetailOpen: false,
            productIdUpdating: null,
            resetOverridesOpen: false,
            summaryComplete: false,
            summaryList: [],
            summaryTableData: [],
            summaryTotal: 0,
            tableLimit: 10000,
            tableOffset: 0,
            tablePage: 0,
            tableSort: {id: 'cs_product_id', desc: false, type: 'string'}
        };

        this.fetchInventoryOrderData = this.fetchInventoryOrderData.bind(this);
        this.handleManualSort = this.handleManualSort.bind(this);
    }

    componentWillMount() {
        this.fetchInventoryOrderData();
    }

    fetchInventoryOrderData() {
        this.setState({
            loading: true
        });

        let params = {
            limit: this.state.tableLimit,
            offset: this.state.tableOffset,
            search: this.state.reportSearch,
            sort: {
                id: this.state.tableSort.id,
                desc: this.state.tableSort.desc
            }
        };
        params.job_id = this.state.jobId;
        params.location_id = this.state.locationId;

        let resource = reportsResources.InventoryOrder.GET_ONE(params);

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data) {
                this.processInventoryOrderData(result.data.details);
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + 'Inventory Order';
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + 'Inventory Order Detail: ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Inventory Order Detail Error: ', error.message);
            }

            this.setState({
                error: true,
                message: message,
                loading: false,
                summaryList: [],
                summaryTableData: [],
                summaryComplete: true,
                summaryTotal: 0
            });
        });
    }

    processInventoryOrderData = (data) => {
        let summaryList = [];
        let summaryTotal = (data) ? data.length : 0;
        const offsetHour = this.state.offsetHour;

        // Assemble Job Detail from one of the products
        let jobDetail = {
            job_id: '',
            job_user: '',
            job_name: '',
            job_created: '',
            job_created_sort: '',
            job_created_str: '',
            location_id: '',
            location_name: '',
            x3_location_id: '',
            x3_location_name: '',
            override_on: '',
            override_on_sort: '',
            override_on_str: '',
            override_by: ''
        };
        if (summaryTotal > 0) {
            let item = data[0];
            jobDetail.job_id = item.job_id;
            jobDetail.job_user = item.job_user;
            jobDetail.job_name = item.job_name;
            jobDetail.job_created = item.job_created;
            jobDetail.job_created_sort = convertDate(item.job_created, 'query-with-time', true);
            jobDetail.job_created_str = convertDate(item.job_created, 'display', true, true, offsetHour, true);
            jobDetail.location_id = item.cs_location;
            jobDetail.location_name = item.x3_location_name;
            jobDetail.x3_location_id = item.x3_location;
            jobDetail.x3_location_name = item.x3_location_name;
            jobDetail.warehouse = item.x3_warehouse;
            jobDetail.warehouse_initial = item.x3_warehouse_initial;
            jobDetail.warehouse_restock = item.x3_warehouse_restock;
            jobDetail.override_on = item.override_on;
            jobDetail.override_on_sort = convertDate(item.override_on, 'query-with-time', true);
            jobDetail.override_on_str = convertDate(item.override_on, 'display', true, true, offsetHour, true);
            jobDetail.override_by = item.override_by;
        }

        // Assemble Product data
        for (let i = 0; i < summaryTotal; i++) {
            let job = data[i];
            if (job && job.job_id) {
                // Set up Case columns and calculations
                job.caseQtyTotal = (job.case_qty) ? addCommas(job.case_qty) : '0';
                job.forecastedCaseQtyTotal = (job.forecasted_case_qty) ? addCommas(job.forecasted_case_qty) : '0';
                job.forecastedPiecesTotal = (job.forecasted_pieces) ? addCommas(job.forecasted_pieces) : '0';
                job.piecesOnHandTotal = (job.pieces_on_hand) ? addCommas(job.pieces_on_hand) : '0';
                let casesOnHand = (job.pieces_on_hand / job.case_qty).toFixed(2);
                if (casesOnHand.includes('.00')) {
                    casesOnHand = casesOnHand.substring(0, casesOnHand.indexOf('.'));
                }
                job.cases_on_hand = casesOnHand;
                job.inTransitTotal = (job.x3_in_transit) ? addCommas(job.x3_in_transit) : '0';
                let available = (job.x3_available) ? job.x3_available : 0;
                let reserved = (job.reserved) ? job.reserved : 0;
                let estimatedAvailable = addCommas(available - reserved);
                if (estimatedAvailable < 0) {
                    estimatedAvailable = 0;
                }
                job.estimated_available = addCommas(estimatedAvailable);

                // Requested Case qty
                let requestedCaseQty = (job.requested_case_qty) ? job.requested_case_qty : 0;
                if (requestedCaseQty < 0) {
                    requestedCaseQty = 0;
                }
                job.requestedCaseQty = addCommas(requestedCaseQty);
                // Add a Requested Case Edit column
                job.requestedCaseQtyEdit = (typeof job.override_case_qty === 'number') ? job.override_case_qty : job.requestedCaseQty;

                // Set up and calculate value columns
                job.forecastedValue = (job.forecasted_value) ? addCommas(job.forecasted_value) : addCommas(0);
                job.onHandValue = (job.on_hand_value) ? addCommas(job.on_hand_value) : addCommas(0);
                // Calculate In Transit Value ((Pieces per Case * In Transit) * Price Each Piece)
                const inTransitCalculated = Math.round((job.case_qty * job.x3_in_transit) * job.price_each);
                job.inTransitValue = (inTransitCalculated) ? addCommas(inTransitCalculated) : addCommas(0);
                // Calculate Requested Value ((Pieces per Case * (Requested Cases)) * Price Each Piece)
                const requestedValueCalculated = Math.round((job.case_qty * job.requestedCaseQtyEdit) * job.price_each);
                job.requestedValue = (requestedValueCalculated) ? addCommas(requestedValueCalculated) : addCommas(0);
                // Calculate plus/minus value (Requested Value - (Forecasted Value - On Hand Value - In Transit Value))
                const plusMinusValue = requestedValueCalculated - (job.forecasted_value - job.on_hand_value - inTransitCalculated);
                job.plusMinusValue = (plusMinusValue) ? addCommas(plusMinusValue) : addCommas(0);
                job.lastYearReturnedValue = (job.last_year_returned_value) ? addCommas(job.last_year_returned_value) : addCommas(0);

                job.override_on_sort = (job.override_on) ? convertDate(job.override_on, 'query-with-time', true) : '';
                job.override_on_str = (job.override_on) ? convertDate(job.override_on, 'display', true, true, offsetHour, true) : '';

                summaryList.push(job);
            }
        }

        let tableSort = {
            id: this.state.tableSort.id,
            desc: (!this.state.tableSort.desc),
            type: this.state.tableSort.type
        };

        this.setState({
            error: false,
            jobDetail: jobDetail,
            loading: false,
            message: null,
            summaryList: summaryList,
            summaryTableData: summaryList,
            summaryComplete: true,
            summaryTotal: summaryTotal,
            tableSort: tableSort
        }, () => {
            this.handleManualSort({id: tableSort.id}, tableSort.type);
            this.processCategoryData();
        });
    };

    processCategoryData = () => {
        const categoryList = [];
        const list = copyObjectArray(this.state.summaryList);

        for (let i = 0; i < list.length; i++) {
            const row = list[i];
            const idx = categoryList.findIndex(r => r.product_category === row.product_category);
            if (idx !== -1) {
                // Update existing row in Category table
                const cat = categoryList[idx];
                // Update Forecasted and On Hand Value totals
                cat.forecasted_value_total = cat.forecasted_value_total + row.forecasted_value;
                cat.forecastedValueTotal = (cat.forecasted_value_total) ? addCommas(cat.forecasted_value_total) : addCommas(0);
                cat.on_hand_value_total = cat.on_hand_value_total + row.on_hand_value;
                cat.onHandValueTotal = (cat.on_hand_value_total) ? addCommas(cat.on_hand_value_total) : addCommas(0);
                // Update Requested Value total
                let requestedValueCalculated = Math.round((row.case_qty * row.requestedCaseQtyEdit) * row.price_each);
                cat.requested_value_total = cat.requested_value_total + requestedValueCalculated;
                cat.requestedValueTotal = (cat.requested_value_total) ? addCommas(cat.requested_value_total) : addCommas(0);
                // Update Plus/Minus Value total
                let inTransitCalculated = Math.round((row.case_qty * row.x3_in_transit) * row.price_each);
                let plusMinusValue = requestedValueCalculated - (row.forecasted_value - row.on_hand_value - inTransitCalculated);
                cat.plus_minus_value_total = cat.plus_minus_value_total + plusMinusValue;
                cat.plusMinusValueTotal = (cat.plus_minus_value_total) ? addCommas(cat.plus_minus_value_total) : addCommas(0);
            } else {
                // Add to Category Table
                const newCat = {
                    product_category: row.product_category,
                    forecasted_value_total: row.forecasted_value,
                    forecastedValueTotal: (row.forecasted_value_total) ? addCommas(row.forecasted_value_total) : addCommas(row.forecasted_value),
                    on_hand_value_total: row.on_hand_value,
                    onHandValueTotal: (row.on_hand_value_total) ? addCommas(row.on_hand_value_total) : addCommas(row.on_hand_value)
                };
                let requestedValueCalculated = Math.round((row.case_qty * row.requestedCaseQtyEdit) * row.price_each);
                newCat.requested_value_total = requestedValueCalculated;
                newCat.requestedValueTotal = (newCat.requested_value_total) ? addCommas(newCat.requested_value_total) : addCommas(0);
                let inTransitCalculated = Math.round((row.case_qty * row.x3_in_transit) * row.price_each);
                newCat.plus_minus_value_total = requestedValueCalculated - (row.forecasted_value - row.on_hand_value - inTransitCalculated);
                newCat.plusMinusValueTotal = (newCat.plus_minus_value) ? addCommas(newCat.plus_minus_value) : addCommas(0);
                categoryList.push(newCat);
            }
        }
        this.setState({
            categoryList: categoryList,
            categoryTableData: categoryList
        });
    };

    processPostInventoryData = (type, params, response) => {
        let error = false;
        let message = '';
        if (response.data && response.data.message && response.data.message.includes('success')) {
            message = 'Success';
            switch (type) {
                case 'location-submit':
                    message = 'This Location Order has been generated. Returning to the Inventory Orders list...';
                    break;
                case 'location-delete':
                    message = 'This Location Order has been deleted. Returning to the Inventory Orders list...';
                    break;
                case 'product-submit':
                    message = 'Product has been submitted';
                    break;
                case 'product-delete':
                    message = 'Product removed from order.';
                    break;
                case 'product-qty-override':
                    message = 'Product requested case quantity updated';
                    break;
                default:
                    message = 'Success';
                    break;
            }
        } else if (response.error) {
            error = true;
            switch (type) {
                case 'location-submit':
                    message = 'Sorry, there was an error generating this Location Order.';
                    break;
                case 'location-delete':
                    message = 'Sorry, this Location order could not be deleted.';
                    break;
                case 'product-submit':
                    message = 'Sorry, the product could not be processed for ordering.';
                    break;
                case 'product-delete':
                    message = 'Sorry, the product could not be removed from this Location Order.';
                    break;
                case 'product-qty-override':
                    message = 'Sorry, there was an issue updating this product\'s requested case quantity.';
                    break;
                default:
                    message = 'Sorry, there was an error';
                    break;
            }
        }

        this.setState({
            error: error,
            loadingLocation: false,
            loadingProduct: false,
            message: message,
            productIdUpdating: null
        }, () => {
            if (params.product_id) {
                const list = copyObjectArray(this.state.summaryList);
                const idx = list.findIndex(r => r.cs_product_id === params.product_id);
                if (idx !== -1) {
                    if (type === 'product-qty-override') {
                        // Update product's override value
                        list[idx].override_case_qty = params.qty;
                        // Add an Override date
                        if (!list[idx].override_on) {
                            list[idx].override_on = new Date().toISOString();
                        }

                        // Update product's in transit value ((Pieces per Case * In Transit) * Price Each Piece)
                        const inTransitCalculated = Math.round((list[idx].case_qty * list[idx].x3_in_transit) * list[idx].price_each);
                        list[idx].inTransitValue = (inTransitCalculated) ? addCommas(inTransitCalculated) : addCommas(0);

                        // Update product's requested value ((Pieces per Case * Requested Cases) * Price Each Piece)
                        const requestedValue = Math.round((list[idx].case_qty * list[idx].override_case_qty) * list[idx].price_each);
                        list[idx].requestedValue = (requestedValue) ? addCommas(requestedValue) : addCommas(0);

                        // Calculate plus/minus value (Requested Value - (Forecasted Value - On Hand Value - In Transit Value))
                        const plusMinusValue = requestedValue - (list[idx].forecasted_value - list[idx].on_hand_value - inTransitCalculated);
                        list[idx].plusMinusValue = (plusMinusValue) ? addCommas(plusMinusValue) : addCommas(0);

                    }
                    if (type === 'product-submit' || type === 'product-delete') {
                        // Remove approved or deleted product from the list
                        list.splice(idx, 1);
                    }
                    this.setState({
                        summaryList: list
                    }, () => {
                        // Accommodate filters in table data after quantity submission
                        const tableData = getTableState(this.inventoryOrderProductsReactTable);
                        this.setState({
                            summaryTableData: tableData
                        });
                        // Update Category table
                        this.processCategoryData();
                    });
                }
            }
            if (type === 'location-submit' || type === 'location-delete') {
                setTimeout(() => {
                    window.location.href = '/#/InventoryOrders';
                }, 800);
            }
        });
    };

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    }

    /**
     * Handle sorting from header click
     *
     * @param col
     * @param type
     */
    handleManualSort(col, type) {
        // Set the current sort column and switch the order
        let tableSort = {
            id: col.id,
            desc: (!this.state.tableSort.desc),
            type: type
        };
        const descStr = (tableSort.desc) ? 'DESC' : 'ASC';

        // Sort list and filtered table data
        let summaryList = [];
        let summaryTableData = [];
        const tableData = getTableState(this.inventoryOrderProductsReactTable);
        if (type === 'currency') {
            summaryList = sortArrayByCurrencyKey(this.state.summaryList, col.id, descStr);
            summaryTableData = sortArrayByCurrencyKey(tableData, col.id, descStr);
        } else {
            summaryList = sortArrayByKey(this.state.summaryList, col.id, descStr);
            summaryTableData = sortArrayByKey(tableData, col.id, descStr);
        }

        this.setState({
            summaryList: summaryList,
            summaryTableData: summaryTableData,
            tableSort: tableSort
        });
    }

    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleCaseQtyEditUpdate = (e, productId) => {
        const inputEl = e.target;
        let value = e.target.value;
        const list = copyObjectArray(this.state.summaryList);
        const idx = list.findIndex(r => r.cs_product_id === productId);
        if (idx !== -1) {
            if (value < 0) {
                value = 0;
            }
            list[idx].requestedCaseQtyEdit = value;
        }
        inputEl.focused = false;
        this.setState({
            error: false,
            message: null,
            summaryList: list
        }, () => {
            // Accommodate filters in table data after input change
            const tableData = getTableState(this.inventoryOrderProductsReactTable);
            this.setState({
                summaryTableData: tableData
            }, () => {
                //name={`edit-case-qty-${row.original.cs_product_id}`}
                inputEl.focus();
            });
        });
    };

    handleCaseQtyEditBlur = (e, productId) => {
        const list = copyObjectArray(this.state.summaryList);
        const idx = list.findIndex(r => r.cs_product_id === productId);
        if (idx !== -1) {
            const caseQty = parseInt(list[idx].requestedCaseQty, 10);
            const caseEdit = parseInt(list[idx].requestedCaseQtyEdit, 10);
            const caseOverridden = parseInt(list[idx].override_case_qty, 10);

            if (isNaN(caseEdit) || list[idx].requestedCaseQtyEdit === '') {
                // Prevent user from clearing edit input
                list[idx].requestedCaseQtyEdit = caseOverridden;

                this.setState({
                    summaryList: list
                }, () => {
                    // Accommodate filters in table data after clearing input
                    const tableData = getTableState(this.inventoryOrderProductsReactTable);
                    this.setState({
                        summaryTableData: tableData
                    });
                });
            } else {
                // If the edited Case Qty has changed from a previously edited amount:
                if (
                    (!isNaN(caseOverridden) && caseEdit === caseQty && caseEdit !== caseOverridden) ||
                    (!isNaN(caseOverridden) && caseEdit !== caseQty && caseEdit !== caseOverridden) ||
                    (isNaN(caseOverridden) && caseEdit !== caseQty)
                ) {
                    const jobDetail = copyObjectArray(this.state.jobDetail);
                    let params = {
                        job_id: jobDetail.job_id,
                        location_id: jobDetail.location_id,
                        product_id: productId,
                        qty: caseEdit
                    };
                    postInventoryOrderData('product-qty-override', params)
                        .then((result) => {
                            this.processPostInventoryData(result.type, result.params, result.data);
                        })
                        .catch(error => {
                            this.processPostInventoryData(error.type, error.params, error.data);
                        });
                }
            }
        }
    };

    handleLocationSubmit = () => {
        this.setState({
            error: false,
            message: null,
            confirmOrderOpen: false,
            confirmOrderType: null,
            loadingLocation: true
        }, () => {
            const jobDetail = copyObjectArray(this.state.jobDetail);
            let params = {
                job_id: jobDetail.job_id,
                location_id: jobDetail.location_id
            };
            postInventoryOrderData('location-submit', params)
                .then((result) => {
                    this.processPostInventoryData(result.type, result.params, result.data);
                })
                .catch(error => {
                    this.processPostInventoryData(error.type, error.params, error.data);
                });
        });
    };

    handleLocationDelete = () => {
        this.setState({
            error: false,
            message: null,
            confirmOrderOpen: false,
            confirmOrderType: null,
            loadingLocation: true
        }, () => {
            const jobDetail = copyObjectArray(this.state.jobDetail);
            let params = {
                job_id: jobDetail.job_id,
                location_id: jobDetail.location_id
            };
            postInventoryOrderData('location-delete', params)
                .then((result) => {
                    this.processPostInventoryData(result.type, result.params, result.data);
                })
                .catch(error => {
                    this.processPostInventoryData(error.type, error.params, error.data);
                });
        });
    };

    handleProductRemove = (action, type, data) => {
        const list = copyObjectArray(this.state.summaryList);
        const idx = list.findIndex(r => r.cs_product_id === data.cs_product_id);
        if (idx !== -1) {
            this.setState({
                error: false,
                message: null,
                loadingProduct: true,
                productIdUpdating: data.cs_product_id
            }, () => {
                const jobDetail = copyObjectArray(this.state.jobDetail);
                let params = {
                    job_id: jobDetail.job_id,
                    location_id: jobDetail.location_id,
                    product_id: data.cs_product_id
                };
                postInventoryOrderData('product-delete', params)
                    .then((result) => {
                        this.processPostInventoryData(result.type, result.params, result.data);
                    })
                    .catch(error => {
                        this.processPostInventoryData(error.type, error.params, error.data);
                    });
                this.setState({
                    confirmRemoveDetail: null,
                    confirmRemoveProductOpen: false
                });
            });
        } else {
            this.setState({
                confirmRemoveDetail: null,
                confirmRemoveProductOpen: false,
            });
        }
    };

    handleAdjustedOrReset = (dialog) => {
        this.fetchInventoryOrderData();
        this.handleDialogClose(dialog);
    };

    handleProductDetailOpen = (e, row) => {
        this.setState({
            productDetail: row,
            productDetailOpen: true
        });
    };

    handleConfirmRemoveProductOpen = (e, row) => {
        this.setState({
            confirmRemoveDetail: row,
            confirmRemoveProductOpen: true
        });
    };

    handleConfirmOrderOpen = (action) => {
        this.setState({
            confirmOrderOpen: true,
            confirmOrderType: action
        });
    };

    handleResetOverridesOpen = (e, row) => {
        this.setState({
            resetOverridesOpen: true
        });
    };

    handleAdjustAvailableOpen = (e, row) => {
        this.setState({
            adjustAvailableOpen: true
        });
    };

    handleDialogClose = (dialog) => {
        if (dialog === 'detail') {
            this.setState({
                error: false,
                message: null,
                productDetail: null,
                productDetailOpen: false
            });
        }
        if (dialog === 'order') {
            this.setState({
                error: false,
                message: null,
                confirmOrderOpen: false,
                confirmOrderType: null
            });
        }
        if (dialog === 'adjust-available') {
            this.setState({
                error: false,
                message: null,
                adjustAvailableOpen: false,
            });
        }
        if (dialog === 'reset-overrides') {
            this.setState({
                error: false,
                message: null,
                resetOverridesOpen: false,
            });
        }
        if (dialog === 'product') {
            this.setState({
                error: false,
                message: null,
                confirmRemoveDetail: null,
                confirmRemoveProductOpen: false
            });
        }
    };

    render() {
        const {
            adjustAvailableOpen,
            categoryList,
            categoryTableData,
            confirmOrderOpen,
            confirmOrderType,
            confirmRemoveDetail,
            confirmRemoveProductOpen,
            error,
            jobDetail,
            jobId,
            loading,
            loadingLocation,
            loadingProduct,
            locationId,
            message,
            productDetail,
            productDetailOpen,
            productIdUpdating,
            resetOverridesOpen,
            summaryComplete,
            summaryList,
            summaryTableData,
            tableSort
        } = this.state;

        const productColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'View',
                        id: 'Inventory-Order-View',
                        Cell: row => {
                            return (
                                <span>
                                    <DetailIcon
                                        onClick={(e) => this.handleProductDetailOpen(e, row.original)}
                                        style={tableStyles.tableIconButton}
                                    />
                                </span>
                            )
                        },
                        filterable: false,
                        sortable: false,
                        width: 60
                    }
                ]
            },
            {
                Header: 'Product Details',
                columns: [
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Product ID</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'string')}
                            />
                        ),
                        accessor: 'cs_product_id',
                        width: 120,
                        sortable: false,
                        style: tableStyles.noWrapText
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Product Name</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'string')}
                            />
                        ),
                        accessor: 'product_name',
                        style: tableStyles.wrapText
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Category</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'string')}
                            />
                        ),
                        accessor: 'product_category',
                        style: tableStyles.wrapText
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Request<br/>Type</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'string')}
                            />
                        ),
                        accessor: 'request_type',
                        width: 90,
                        style: tableStyles.noWrapText
                    }
                ]
            },
            {
                Header: 'Cases',
                columns: [
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Forecasted<br/>Cases</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'forecastedCaseQtyTotal',
                        width: 90,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Cases<br/>On Hand</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'cases_on_hand',
                        width: 90,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>In<br/>Transit</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'inTransitTotal',
                        width: 90,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Requested<br/>Cases</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'requestedCaseQty',
                        width: 90,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Override<br/>Requested</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'requestedCaseQtyEdit',
                        width: 100,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        Cell: row => (
                            <input
                                ref={(e) => (this.input = e)}
                                type="number"
                                min={0}
                                name={`edit-case-qty-${row.original.cs_product_id}`}
                                value={row.original.requestedCaseQtyEdit}
                                onChange={(e) => this.handleCaseQtyEditUpdate(e, row.original.cs_product_id)}
                                onBlur={(e) => this.handleCaseQtyEditBlur(e, row.original.cs_product_id)}
                                autoFocus={false}
                                style={(row.original.override_on && row.original.override_case_qty !== row.original.requestedCaseQty) ? {...styles.qtyInput, ...styles.qtyModified} : styles.qtyInput}
                                disabled={(loadingProduct && productIdUpdating === row.original.cs_product_id)}
                            />
                        ),
                        className: 'no-arrows',
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Estimated<br/>Available</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'estimated_available',
                        width: 90,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.noWrapText}
                    },
                ]
            },
            {
                Header: 'Values',
                columns: [
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Forecasted<br/>Value</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'forecastedValue',
                        width: 135,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        Filter: () => <TotalsFilter
                            accessor="forecastedValue" list={summaryList} filteredList={summaryTableData}/>,
                        style: {...tableStyles.right, ...tableStyles.noWrapText},
                        Footer: (
                            <TotalsFilter
                                accessor="forecastedValue" list={summaryList} filteredList={summaryTableData}/>
                        )
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>On Hand<br/>Value</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'onHandValue',
                        width: 135,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        Filter: () => <TotalsFilter
                            accessor="onHandValue" list={summaryList} filteredList={summaryTableData}/>,
                        style: {...tableStyles.right, ...tableStyles.noWrapText},
                        Footer: (
                            <TotalsFilter
                                accessor="onHandValue" list={summaryList} filteredList={summaryTableData}/>
                        )
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>In Transit<br/>Value</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'inTransitValue',
                        width: 135,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        Filter: () => <TotalsFilter
                            accessor="inTransitValue" list={summaryList} filteredList={summaryTableData}/>,
                        style: {...tableStyles.right, ...tableStyles.noWrapText},
                        Footer: (
                            <TotalsFilter
                                accessor="inTransitValue" list={summaryList} filteredList={summaryTableData}/>
                        )
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>Requested<br/>Value</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'requestedValue',
                        width: 135,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        Filter: () => <TotalsFilter
                            accessor="requestedValue" list={summaryList} filteredList={summaryTableData}/>,
                        style: {...tableStyles.right, ...tableStyles.noWrapText},
                        Footer: (
                            <TotalsFilter
                                accessor="requestedValue" list={summaryList} filteredList={summaryTableData}/>
                        )
                    },
                    {
                        Header: (col) => (
                            <TableHeaderWithSort
                                col={col} sort={tableSort} title={<span>+ / -</span>}
                                onSortFunc={(e) => this.handleManualSort(e, 'currency')}
                            />
                        ),
                        accessor: 'plusMinusValue',
                        width: 135,
                        sortMethod: (a, b) => sortCurrency(a, b),
                        Filter: () => <TotalsFilter
                            accessor="plusMinusValue" list={summaryList} filteredList={summaryTableData}/>,
                        style: {...tableStyles.right, ...tableStyles.noWrapText},
                        Footer: (
                            <TotalsFilter
                                accessor="plusMinusValue" list={summaryList} filteredList={summaryTableData}/>
                        )
                    }
                ]
            },
            {
                Header: '',
                columns: [
                    {
                        Header: '',
                        id: 'Inventory-Order-Buttons',
                        Cell: row => {
                            const isUpdating = (loadingProduct && productIdUpdating === row.original.cs_product_id);
                            return (
                                <span>
                                    <RaisedButton
                                        size="small"
                                        style={tableStyles.tableBtn}
                                        buttonStyle={tableStyles.tableBtnStyle}
                                        label="Remove"
                                        labelStyle={tableStyles.tableBtnLabel}
                                        labelColor={FuseTheme.palette.accent2Color}
                                        backgroundColor={FuseTheme.palette.accent1Color}
                                        onClick={(e) => this.handleConfirmRemoveProductOpen(e, row.original)}
                                        tabIndex={-1}
                                        disabled={(isUpdating)}
                                    />
                                </span>
                            )
                        },
                        filterable: false,
                        sortable: false,
                        width: 110
                    }
                ]
            }
        ];

        const categoryColumns = [
            {
                Header: () => (<span>Category</span>),
                accessor: 'product_category',
                filterable: false,
                style: tableStyles.wrapText
            },
            {
                Header: () => (<span>Forecasted<br/>Value</span>),
                accessor: 'forecastedValueTotal',
                width: 135,
                sortMethod: (a, b) => sortCurrency(a, b),
                Filter: () => <TotalsFilter
                    accessor="forecastedValueTotal" list={categoryList} filteredList={categoryTableData}/>,
                style: {...tableStyles.right, ...tableStyles.noWrapText},
                Footer: (
                    <TotalsFilter
                        accessor="forecastedValueTotal" list={categoryList} filteredList={categoryTableData}/>
                )
            },
            {
                Header: () => (<span>On Hand<br/>Value</span>),
                accessor: 'onHandValueTotal',
                width: 135,
                sortMethod: (a, b) => sortCurrency(a, b),
                Filter: () => <TotalsFilter
                    accessor="onHandValueTotal" list={categoryList} filteredList={categoryTableData}/>,
                style: {...tableStyles.right, ...tableStyles.noWrapText},
                Footer: (
                    <TotalsFilter
                        accessor="onHandValueTotal" list={categoryList} filteredList={categoryTableData}/>
                )
            },
            {
                Header: () => (<span>Requested<br/>Value</span>),
                accessor: 'requestedValueTotal',
                width: 135,
                sortMethod: (a, b) => sortCurrency(a, b),
                Filter: () => <TotalsFilter
                    accessor="requestedValueTotal" list={categoryList} filteredList={categoryTableData}/>,
                style: {...tableStyles.right, ...tableStyles.noWrapText},
                Footer: (
                    <TotalsFilter
                        accessor="requestedValueTotal" list={categoryList} filteredList={categoryTableData}/>
                )
            },
            {
                Header: () => (<span>+ / -</span>),
                accessor: 'plusMinusValueTotal',
                width: 135,
                sortMethod: (a, b) => sortCurrency(a, b),
                Filter: () => <TotalsFilter
                    accessor="plusMinusValueTotal" list={categoryList} filteredList={categoryTableData}/>,
                style: {...tableStyles.right, ...tableStyles.noWrapText},
                Footer: (
                    <TotalsFilter
                        accessor="plusMinusValueTotal" list={categoryList} filteredList={categoryTableData}/>
                )
            }
        ];

        const defaultCategorySort = setDefaultTableSort({field: 'product_category', order: 'DESC'});


        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Inventory Order Details</span>;

        return (
            <div className="lists-container">
                <Card>
                    <ShowActions basePath="/InventoryOrders"/>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>
                                View this Order's products and their forecasted cases. You may also review this Order
                                by its Categories.
                            </p>
                            <p>
                                In the Products for Locations table, you may edit the <em>Requested Cases</em> quantity
                                foreach product, or remove the product from this order. To edit a product's requested
                                cases, simply update its <em>Override Requested</em> field.
                            </p>
                            <p>
                                To adjust all products' requested cases to match the estimated available,
                                click <strong>Adjust to Available</strong>. To reset all overridden requested cases
                                to their original requested amounts,click <strong>Reset Overrides</strong>.
                            </p>
                            <p>
                                You may generate this order or delete it.
                            </p>
                        </span>
                        {summaryComplete &&
                            <div className="report-header">
                                {/* Table: Inventory Order by Location Details */}
                                <InventoryOrderDetailTable jobDetail={jobDetail}/>
                            </div>
                        }
                        {summaryComplete &&
                            <div style={styles.container}>
                                <div style={tableStyles.btnContainer}>
                                    {/* Order Buttons */}
                                    <RaisedButton
                                        size="medium"
                                        label="Generate order"
                                        style={tableStyles.btn}
                                        labelColor={FuseTheme.palette.accent2Color}
                                        backgroundColor={FuseTheme.palette.primary1Color}
                                        disabled={(!summaryComplete || summaryList.length === 0)}
                                        onClick={() => this.handleConfirmOrderOpen('submit')}
                                    />
                                    <RaisedButton
                                        size="medium"
                                        label="Delete Order"
                                        style={tableStyles.btn}
                                        labelColor={FuseTheme.palette.accent2Color}
                                        backgroundColor={FuseTheme.palette.accent1Color}
                                        disabled={(!summaryComplete || summaryList.length === 0)}
                                        onClick={() => this.handleConfirmOrderOpen('delete')}
                                    />
                                    <RaisedButton
                                        size="medium"
                                        label="Adjust to Available"
                                        style={tableStyles.btn}
                                        labelColor={FuseTheme.palette.accent2Color}
                                        backgroundColor={FuseTheme.palette.primary1Color}
                                        disabled={(!summaryComplete || summaryList.length === 0)}
                                        onClick={() => this.handleAdjustAvailableOpen()}
                                    />
                                    <RaisedButton
                                        size="medium"
                                        label="Reset Overrides"
                                        style={tableStyles.btn}
                                        labelColor={FuseTheme.palette.accent2Color}
                                        backgroundColor={FuseTheme.palette.primary1Color}
                                        disabled={(!summaryComplete || summaryList.length === 0)}
                                        onClick={() => this.handleResetOverridesOpen()}
                                    />
                                    {loadingLocation &&
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            className="loader"
                                        />
                                    }
                                </div>
                            </div>
                        }
                        {!summaryComplete && !error &&
                            <div className="loader-container">
                                <h4>Retrieving Inventory Order details...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                        }
                        <div className={(error) ? 'error' : ''}>
                            {message &&
                                <p>{message}</p>
                            }
                            {!message &&
                                <p>&nbsp;</p>
                            }
                        </div>

                        {summaryComplete &&
                            <div className="reports-table-container">

                                {/* Table Header: Inventory Order Products */}
                                <div className="reports-table-title table-table-header">
                                    <div className="btn-report-container report-header-button-container">
                                        <FlatButton
                                            label="Refresh"
                                            labelStyle={{color: "#FFFFFF"}}
                                            icon={<RefreshIcon color="#FFFFFF"/>}
                                            onClick={() => this.fetchInventoryOrderData()}
                                        />
                                    </div>
                                    <h3 className="table-table-header-title">
                                        <span>Products for Location {jobDetail.location_id} ({jobDetail.x3_location_id}) - {jobDetail.location_name}</span>
                                    </h3>
                                </div>

                                {/* Table: Inventory Order Products */}
                                <ExpandableTableContainer>
                                    <ReactTable
                                        key="table-inventory-order-products"
                                        data={summaryList}
                                        columns={productColumns}
                                        defaultPageSize={10000}
                                        showPagination={false}
                                        sortable={false}
                                        filterable
                                        defaultFilterMethod={filterCaseInsensitive}
                                        loading={loading}
                                        onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.inventoryOrderProductsReactTable)}
                                        ref={(r) => this.inventoryOrderProductsReactTable = r}
                                        resizable={false}
                                        minRows={1}
                                        className="-striped"
                                    />
                                </ExpandableTableContainer>

                                {/* Table Header: Inventory Order Categories */}
                                <div className="reports-table-title table-table-header">
                                    <h3 className="table-table-header-title">
                                        <span>Categories for Location {jobDetail.location_id} ({jobDetail.x3_location_id}) - {jobDetail.location_name}</span>
                                    </h3>
                                </div>

                                {/* Table: Inventory Order Categories */}
                                <ExpandableTableContainer>
                                    <ReactTable
                                        key="table-inventory-order-categories"
                                        data={categoryList}
                                        columns={categoryColumns}
                                        defaultPageSize={10000}
                                        showPagination={false}
                                        sortable={true}
                                        defaultSorted={defaultCategorySort}
                                        filterable
                                        loading={loading}
                                        resizable={false}
                                        minRows={1}
                                        className="-striped small"
                                    />
                                </ExpandableTableContainer>
                            </div>
                        }
                    </CardText>
                </Card>

                {/* Dialog: Product Detail */}
                <Dialog
                    modal={false}
                    open={productDetailOpen}
                    onRequestClose={() => this.handleDialogClose('detail')}
                    contentClassName="dialogContentTable"
                    autoScrollBodyContent={true}
                    actions={<FlatButton
                        label="Close"
                        primary={true}
                        onClick={() => this.handleDialogClose('detail')}
                    />}
                >
                    {productDetail &&
                        <DialogInventoryOrderProductDetail data={productDetail}/>
                    }
                </Dialog>

                {/* Dialog: Remove Product Confirmation */}
                <Dialog
                    modal={false}
                    open={confirmRemoveProductOpen}
                    onRequestClose={() => this.handleDialogClose('product')}
                    contentClassName="dialogContentTable"
                    autoScrollBodyContent={true}
                >
                    {confirmRemoveDetail &&
                        <DialogInventoryOrderConfirm
                            data={confirmRemoveDetail}
                            type="product"
                            action="delete"
                            onSubmit={(action, type, data) => this.handleProductRemove(action, type, data)}
                            onCancel={() => this.handleDialogClose('product')}
                        />
                    }
                </Dialog>

                {/* Dialog: Submit/Delete Order Confirmation */}
                <Dialog
                    modal={false}
                    open={confirmOrderOpen}
                    onRequestClose={() => this.handleDialogClose('order')}
                    contentClassName="dialogContentTable"
                    autoScrollBodyContent={true}
                >
                    {summaryComplete &&
                        <Fragment>
                            {confirmOrderType === 'submit' &&
                                <DialogInventoryOrderConfirm
                                    data={jobDetail}
                                    type="order"
                                    action="submit"
                                    onSubmit={this.handleLocationSubmit}
                                    onCancel={() => this.handleDialogClose('order')}
                                />
                            }
                            {confirmOrderType === 'delete' &&
                                <DialogInventoryOrderConfirm
                                    data={jobDetail}
                                    type="order"
                                    action="delete"
                                    onSubmit={this.handleLocationDelete}
                                    onCancel={() => this.handleDialogClose('order')}
                                />
                            }
                        </Fragment>
                    }
                </Dialog>

                {/* Dialog: Adjust Case Quantities to Average */}
                <Dialog
                    modal={false}
                    open={adjustAvailableOpen}
                    onRequestClose={() => this.handleDialogClose('adjust-available')}
                    contentClassName="dialogContentTable"
                    autoScrollBodyContent={true}
                >
                    <Fragment>
                        {summaryComplete &&
                            <DialogInventoryOrderAdjustToAvailable
                                jobId={jobId}
                                locationId={locationId}
                                onSuccess={() => this.handleAdjustedOrReset('adjust-available')}
                                onCancel={() => this.handleDialogClose('adjust-available')}
                            />
                        }
                    </Fragment>
                </Dialog>

                {/* Dialog: Reset Case Quantity Overrides */}
                <Dialog
                    modal={false}
                    open={resetOverridesOpen}
                    onRequestClose={() => this.handleDialogClose('reset-overrides')}
                    contentClassName="dialogContentTable"
                    autoScrollBodyContent={true}
                >
                    <Fragment>
                        {summaryComplete &&
                            <DialogInventoryOrderResetOverrides
                                jobId={jobId}
                                locationId={locationId}
                                onSuccess={() => this.handleAdjustedOrReset('reset-overrides')}
                                onCancel={() => this.handleDialogClose('reset-overrides')}
                            />
                        }
                    </Fragment>
                </Dialog>

            </div>
        )
    }
}

InventoryOrderDetail.propTypes = {
    id: PropTypes.string
};

export default InventoryOrderDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryOrderDetail.js